// extracted by mini-css-extract-plugin
module.exports = {"Logo":"RegisterWUCUserForm_Logo__3T_75","btn":"RegisterWUCUserForm_btn__1jP3P"};